import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { postSession } from '../lib/api';
import { useAuth } from '../lib/AuthContext';
import { GraduationCap, Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      const hash = window.location.hash || '';
      const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
      const sid = params.get('session_id');
      if (!sid) {
        navigate('/admin/login', { replace: true });
        return;
      }
      try {
        const u = await postSession(sid);
        setUser(u);
        window.history.replaceState(null, '', '/admin');
        navigate('/admin', { replace: true, state: { user: u } });
      } catch (e) {
        navigate('/admin/login?err=1', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-teal-600 grid place-items-center text-white shadow-lg">
          <GraduationCap className="w-8 h-8" />
        </div>
        <div className="mt-4 flex items-center gap-2 justify-center text-slate-600">
          <Loader2 className="w-4 h-4 animate-spin" /> Completing sign-in...
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
